<template>
  <div class="uid-intro">
    <div class="popup-shadow" @click="hidePopup"></div>
    <div class="popup-container">
      <a href="javascript:void(0);" class="popup-close" @click="hidePopup"></a>
      <iframe
        title=""
        class="popup-content"
        :src="guidePopLink"
      ></iframe>
    </div>
  </div>
</template>

<script type="text/javascript">
export default {
  name: 'UidTokenGuidePopup2',
  props: ['guidePopLink'],
  methods: {
    hidePopup() {
      this.$emit('hidePopup');
    },
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/base.scss';
$imgUrl: '../../assets/image/webLogin/';

.uid-intro {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1001;
}

.popup-shadow {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
}

.popup-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  height: 90%;
  box-sizing: border-box;
  overflow: hidden;
  // padding: 0 4.5vmin 7.6vmin;
}

.popup-close {
  position: absolute;
  top: 3.4vmin;
  right: 5.1vmin;
  display: block;
  width: 2.8vmin;
  height: 2.8vmin;
  background: url('../../assets/image/webStore/close.png') no-repeat
    center/contain;
  z-index: 100;
}

.popup-content {
  width: 100%;
  height: 100%;
  z-index: 1;
}


@media screen and (orientation: landscape) {
  .popup-container {
    width: 53.3vmin;
  }
}

@media screen and (orientation: landscape) and (max-width: 1000px) {
  .popup-container {
    width: 50%;
  }
}
</style>
